import 'fullcalendar/dist/fullcalendar.min.js';
import 'fullcalendar/dist/fullcalendar.min.css';

export default (function () {
  $('#full-calendar').fullCalendar({
      eventSources: window.calendar,
      height:800,
      editable : true,
      header: {
        left   : 'month,basicWeek',
        center : '',
        right  : 'prev, title, next',
      },
      displayEventTime:false,
      locale: 'ru',
      buttonText: {
          today: "Сегодня",
          month: "Месяц",
          week: "Неделя",
          day: "День"
      },
      dayClick: function(date) {
        eventDay(date.format());
      },
      eventRender: function(eventObj, $el) {
        $el.popover({
          title: eventObj.title,
          content: eventObj.description.substring(0,100),
          trigger: 'hover',
          placement: 'top',
          container: 'body',
          html:true
        });
      },
      eventClick: function(calEvent, jsEvent, view) {
        var template = Handlebars.compile($("#detail-template").html());
        $('#calendar-detail').find('.modal-body').html(template(calEvent));
        $('#calendar-detail').find('.modal__title').html(calEvent.title);
        $('#calendar-detail').modal('show');
      }

  });

  $('body').on('change','.resources',function(){
    var $this = $(this);
    $('.resources').each(function(i,item){
      var $item = $(item);
      $item.parents('label').addClass('unselected');
      $('#full-calendar').fullCalendar('removeEventSource', window.calendar[$item.val()]);
    })
    $('.resources:checked').each(function(i,item){
      var $item = $(item);
      $item.parents('label').removeClass('unselected');
      $('#full-calendar').fullCalendar('addEventSource', window.calendar[$item.val()]);
    })
    
    $('#full-calendar').fullCalendar('refetchEvents');
  });

  function eventDay(date){
    $.ajax({
      url:'events/eventDay',
      type:'GET',
      data:{date:date},
      headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
      success:function(data){
        $('.eventDay').replaceWith(data);
      }
    });
  }


  $('body').on('show.bs.modal','#calendar-edit', function (event) {
    var button = $(event.relatedTarget);
    var template = Handlebars.compile($("#edit-template").html());
    if(button.data('target')=='#calendar-edit'){
      var action = button.data('action');
      var modal = $(this);
      modal.find('.modal-body').html(template(button.data()));
      modal.find('form').attr('action',button.data('url'));
      modal.find('[name=_method]').val(button.data('method'));
      initDatapickerRange();
      if(action=='edit'){
          modal.find('.modal__title').html('Редактирование события');
          $('#calendar-edit').find('.end__date').datepicker('setStartDate',button.data('start'));
          $('#calendar-edit').find('.start__date').datepicker('setEndDate',button.data('end'));
      }else{
          modal.find('.modal__title').html('Создание события');
      }
      if(button.data('city')){
        modal.find('.modal-body').find('option[value='+button.data('city')+']').attr('selected',true);
      }
      
      $('.selectpicker').selectpicker();
      ClassicEditor
      .create( document.querySelector( '#editor' ),{
      toolbar: ['bold', 'italic', 'link', 'bulletedList', 'numberedList' ]}
         )
      .catch( error => {
          console.error( error );
      } );
    }
  })

  $('body').on('show.bs.modal','#calendar-detail', function (event) {
    var button = $(event.relatedTarget);
    var title = button.data('title');
    if(title){
      var modal = $(this);
      modal.find('.modal__title').html(title);
      var template = Handlebars.compile($("#detail-template").html());
      modal.find('.modal-body').html(template(button.data()));
    }
  })

  $('body').on('click','.delete__event',function(e){
    e.preventDefault();
    var $this=$(this);
    var $form=$this.parents('.delete__block').find('.deleteEvent');
    $.ajax({
      url:$form.attr('action'),
      type:$form.attr('method'),
      data:$form.serialize(),
      success:function(){
        $('#full-calendar').fullCalendar( 'refetchEvents' );
        $this.parents('.event').remove();
      }
    });
    
  })

  $('body').on('submit','.eventForm',function(e){
    e.preventDefault();
    var $form = $(this);
    var $button = $form.find('.modal__button');
    if($form.find('textarea').val().length) {
      $button.addClass('disabled');
      $button.prepend('<i class="fas fa-circle-notch fa-spin mR-10"></i>');
      $.ajax({
        url:$form.attr('action'),
        type:$form.attr('method'),
        data:$form.serialize(),
        success:function(data){
          eventDay($('.eventDay').data('date'));
          $('#calendar-edit').find('.end__date').datepicker('setStartDate',false);
          $('#calendar-edit').find('.start__date').datepicker('setEndDate',false);
          $('#calendar-edit').modal('hide');
          $('#full-calendar').fullCalendar( 'refetchEvents' );
          $button.removeClass('disabled');
          $button.find('i').remove();
        }
      });
    } else {
      alert('Заполните описание')
    }
    
  })
  function initDatapickerRange(){
      var option={language: 'ru'};
      $('.start__date').datepicker(option).on('changeDate',function(e){
          var $this=$(this);
          $this.parents('.datapicker__range').find('.end__date').datepicker('setStartDate',$this.val());
      });

      $('.end__date').datepicker(option).on('changeDate',function(e){
          var $this=$(this);
          $this.parents('.datapicker__range').find('.start__date').datepicker('setEndDate',$this.val());
      });
  }

  $('body').on('click','.user__select',function(){
    var $this = $(this);
    var $parent = $(this).parents('.event_user_block');
    var $result = $parent.find('.search__result');
    $result.removeClass('show');
    var $input = $parent.find('.find__user');
    $input.val('')
    if(!$parent.find('.user_event_input[value='+$this.data('id')+']').length) {
      $parent.find('.event_users').append('<div class="event_user">'+
        '<input name="users[]" value="'+$this.data('id')+'" class="user_event_input" hidden>'+
        '<div class="d-flex align-items-center">'+
          '<div class="">'+
            '<h6 class="text-hidden m-0 c-grey-900">'+$this.data('name')+'</h6>'+
          '</div>'+
          '<button class="unsubscribe__user"><i class="c-light-white-500 ti-trash"></i></button>'+
        '</div>'+
      '</div>')
    }
  })

  $('body').on('click','.user__select__team',function(){
    var $this = $(this);
    var $parent = $(this).parents('.team_user_block');
    var $result = $parent.find('.search__result');
    $result.removeClass('show');
    var $input = $parent.find('.find__user');
    $input.val($this.data('email'))
    
  })

  $('body').on('click','.unsubscribe__user',function(){
    var $this = $(this);
    $this.parents('.event_user').remove();
  })
  
  $('body').on('keyup','.find__user', _.debounce(function(e){
    var $this = $(this);
    var $parent = $(this).parents('.search__div');
    var $result = $parent.find('.search__result');
    if($this.data('select')) {
      var user_select = $this.data('select')
    } else {
      var user_select = 'user__select'
    }
    if($this.val().length>3){
        $.ajax({
            url:$this.data('url'),
            method:'GET',
            data:{ q:$this.val() },
            success: function(json){
                if(json.status){
                    if(json.users.length){
                        $result.empty();
                        json.users.forEach(function(item){
                            $result.append('<li class="no-after peers fxw-nw ai-c lh-1 '+user_select+'" data-id="'+item.id+'" data-email="'+item.email+'" data-name="'+item.name+'">'+
                                '<div class="peer mR-10">'+
                                    '<div class="w-3r h-3r bdrs-50p ps" style="background: url('+item.avatar+');background-size: cover;background-position: 50% 50%;"></div>'+
                                '</div>'+
                                '<div class="peer">'+
                                    '<span class="fsz-sm c-grey-900 d-block">'+item.name+'</span>'+
                                    '<span class="fsz-sm c-grey-700 d-block mT-10">'+item.email+'</span>'+
                                '</div>'+
                            '</li>');
                            $result.addClass('show');
                        })
                    }else{
                        $result.removeClass('show');
                    }
                }
            },
            error: function(){
                $result.removeClass('show');
            }
        })
    }else{
        $result.removeClass('show');
    }
},300));
}())
